import { combineReducers } from '@reduxjs/toolkit';
import authReducer from "../coach/reducers/authReducer"
import coachesReducer from "../coach/reducers/coachReducer"

const coachReducer = combineReducers({
  auth: authReducer,
  coach: coachesReducer
});

export default coachReducer;
